<template>
  <a-card>
    <TableView
      v-if="tableData.length"
      :columns="tableColumns"
      :data="tableData"
      :pagination="false"
      :loading="tableLoading"
      :scroll="{ x: 800 }"
    >
      <template v-slot:time="{ tableRow }">
        <a-date-picker
          size="small"
          v-if="tableRow.isEdit"
          mode="year"
          :value="tableRow.pickerTime"
          :open="tableRow.isOpen"
          format="YYYY"
          placeholder=""
          @openChange="status => handleOpenChange(status, tableRow)"
          @panelChange="val => handlePanelChange(val, tableRow)"
          @change="handleChange(tableRow)"
        />
        <template v-else>{{ tableRow.time }}</template>
      </template>
      <template
        v-for="item in tableColumnsKey"
        v-slot:[item.dataIndex]="{ tableRow, index }"
      >
        <item
          :list="tableRow"
          :itemKey="item.dataIndex"
          :key="item.dataIndex"
          :ref="`rowItem_${index}`"
        ></item>
      </template>
      <template v-slot:action="{ tableRow, index }">
        <a-button
          v-if="!tableRow.isEdit"
          type="link"
          size="small"
          @click="handleEdit(tableRow)"
        >
          编辑
        </a-button>
        <div v-else>
          <a-button
            type="link"
            size="small"
            @click="handleSave(tableRow, index)"
          >
            保存
          </a-button>
          <a-divider type="vertical" />
          <a-popconfirm title="确定取消?" @confirm="handleCancel(tableRow)">
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a-button type="link" size="small">
              取消
            </a-button>
          </a-popconfirm>
        </div>
      </template>
    </TableView>
    <a-button type="dashed" block class="add-btn" @click="handleAdd">
      <a-icon type="plus" />
      添加
    </a-button>
  </a-card>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import { getTableData, addItem } from './api'
import item from './item'
import mixin from './mixin'
import moment from 'moment'

export default {
  mixins: [mixin],
  components: { TableView, item },
  data() {
    return {
      isOpen: false,
      tableLoading: true,
      num: 0,
    }
  },
  computed: {
    tableColumnsKey() {
      const newArr = [...this.tableColumns]
      newArr.pop()
      newArr.shift()
      return newArr
    },
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    // 获取表格数据
    _getTableData() {
      getTableData().then(({ data }) => {
        this.tableData = data.map(item => ({
          ...item,
          isEdit: false,
          pickerTime: moment(item.time, 'YYYY'),
          isOpen: false,
        }))
        this.tableLoading = false
      })
    },
    // 点击日期输入框弹出选择框
    handleOpenChange(status, data) {
      data.isOpen = status
    },
    // 选择日期后关闭选择框
    handlePanelChange(value, data) {
      data.pickerTime = value
      data.isOpen = false
      data.time = moment(value).format('YYYY')
    },
    // 点击编辑按钮
    handleEdit(tableRow) {
      tableRow.isEdit = true
    },
    // 保存
    handleSave(data, index) {
      let newData = { id: '' }
      this.$refs[`rowItem_${index}`].forEach(item => {
        newData = { ...newData, ...item.getRowData() }
      })
      if (data.id) {
        newData.id = data.id
      }
      newData.time = data.time

      for (const key in newData) {
        if (!newData[key] && key !== 'id') {
          this.$notification.warning({
            message: '提示',
            description: '输入框不能为空',
          })
          return
        }
      }

      addItem(newData).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        data = Object.assign(data, { ...newData, isEdit: false })
      })
    },
    // 新增
    handleAdd() {
      this.tableData.push({
        avgAccountPeriod: '',
        stdExpiryRate: '',
        mbgExpiryRate: '',
        avgPurchase: '',
        growthRate: '',
        isEdit: true,
        isOpen: false,
        time: '',
        id: this.num++,
        newItem: true,
      })
    },
    // 取消
    handleCancel(tableRow) {
      if (tableRow.newItem) {
        this.tableData.pop()
      } else {
        tableRow.isEdit = false
      }
    },
    // 点击日期框清除按钮
    handleChange(data) {
      data.pickerTime = null
      data.time = ''
    },
  },
}
</script>

<style scoped lang="less">
.add-btn {
  margin-top: 20px;
}
</style>
